module.exports = __webpack_public_path__ + "static/img/blog-3.95681f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/interthings/blog-3.jpg
// module id = 5SWd
// module chunks = 4